var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "persistent": "",
      "max-width": "1200",
      "title": "리본바이옴 판매 계약서"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }, {
      key: "foot",
      fn: function () {
        return [_vm.hasFile ? _c('v-row', {
          staticClass: "ma-n2"
        }, [_c('v-col', {
          staticClass: "pa-2",
          attrs: {
            "cols": "6"
          }
        }, [_c('view-file', {
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref2) {
              var attrs = _ref2.attrs,
                on = _ref2.on;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "v-size--xx-large",
                attrs: {
                  "block": "",
                  "color": "primary",
                  "outlined": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("첨부파일 확인")])];
            }
          }], null, false, 1705754974),
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v;
            },
            expression: "form"
          }
        })], 1), _c('v-col', {
          staticClass: "pa-2",
          attrs: {
            "cols": "6"
          }
        }, [_c('v-btn', {
          staticClass: "v-size--xx-large",
          attrs: {
            "block": "",
            "color": "primary"
          },
          on: {
            "click": _vm.down
          }
        }, [_vm._v("계약서 다운로드")])], 1)], 1) : [_c('v-btn', {
          staticClass: "v-size--xx-large",
          attrs: {
            "block": "",
            "color": "primary"
          },
          on: {
            "click": _vm.down
          }
        }, [_vm._v("계약서 다운로드")])]];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "overflow": "hidden"
    }
  }, [_c('employment-doc-view', _vm._b({
    ref: "employment-doc-view"
  }, 'employment-doc-view', {
    contract: _vm.form,
    value: _vm.fields,
    pages: _vm.pages,
    mode: 'done'
  }, false))], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }